import React from 'react';
import Loading from '../../../gd-ui/loading/loading';
// @ts-ignore
import View from './components/view.jsx';
import ApiIntegrationGoogleDrive from "../../../gd/api/integrations/google-drive";
import ApiIntegrationRequest from "../../../gd/api-request/api-intergration";

type Props = {
    params : any
}

type State = {
    folderId: ID | null
    loading : boolean
    data    : any
    rootFolderName : string
}

class ModalGoogleDriveView extends React.Component<Props, State> {

    public isMounted : boolean

    constructor(props: Props) {
        super(props)

        this.isMounted = false
        this.state = {
            folderId: null,
            loading: true,
            data: null,
            rootFolderName: "Google drive"
        };
    }

    componentDidMount() {
        const { type } = this.props.params;
        this.loadDriveData(type === 'setRoot' ? 'root' : null);
        this.isMounted = true
    }

    componentWillUnmount() {
        this.isMounted = false
    }

    loadDriveData = (folderId: ID | null) => {
        const { type } = this.props.params;
        const id = folderId ? folderId : (type === 'setRoot' ? 'root' : 'gd_root');

        const request = ApiIntegrationGoogleDrive.listFiles(id)

        request.done(data=>{
            if(this.isMounted){
                this.setState({
                    folderId: folderId,
                    loading: false,
                    rootFolderName: data.rootFolderName ? data.rootFolderName : this.state.rootFolderName,
                    data: data.files
                });
            }
        });
    };

    onAttachFiles = (files: ID) => {
        const { onAttachFiles } = this.props.params;
        if (onAttachFiles) onAttachFiles(files);
    };

    onFolderClick = (folderId: ID) => {
        this.loadDriveData(folderId);
    };

    onDeleteClick = (id: ID) => {
        const { organizationId } = this.props.params;
        const request = ApiIntegrationRequest.GET(this,'gdrive/delete/'+organizationId+'/'+id);

        request.done((data: any)=>{
            this.onRefresh();
        });

    };

    onAddFolder = (folderName: string, type: any) => {
        const { organizationId } = this.props.params;
        const { folderId } = this.state;
        let baseRoot;
        switch(type) {
            case "setRoot": baseRoot = 'root'; break;
            case "attachFile": baseRoot = 'gd_root'; break;
        }
        const id = folderId ? folderId : baseRoot;

        const request = ApiIntegrationRequest.POST(this,'gdrive/mkdir/'+organizationId+'/'+id, {
            name: folderName
        });

        request.done((data: any)=>{
            this.onRefresh();
        });
    };

    onSelectRoot = (folderObject: any) => {
        const { organizationId } = this.props.params;
        const { folderId } = this.state;

        if (folderId) {
            const request = ApiIntegrationRequest.POST(this,'gdrive/set_root/'+organizationId, {
                folder_id: folderId
            });

            request.done((d: any)=>{
                const { onChangeRoot } = this.props.params;
                if (onChangeRoot) onChangeRoot(folderObject.name);
                this.onRefresh();
            });
        }
    };

    onUpload = (formData: any, type: any) => {
        const { organizationId } = this.props.params;
        const { folderId, data } = this.state;
        let baseRoot;
        switch(type) {
            case "setRoot": baseRoot = 'root'; break;
            case "attachFile": baseRoot = 'gd_root'; break;
        }
        const id = folderId ? folderId : baseRoot;

        const newData = data.slice();
        newData.push({
            name: formData.get("uploaded").name,
            mimeType: "file"
        });

        this.setState({
            data: newData
        }, ()=>{
            const request = ApiIntegrationRequest.UPLOAD(this,'gdrive/upload/'+organizationId+'/'+id, formData);

            request.done((data: any)=>{
                this.onRefresh();
            });
        });
    };

    onRefresh = () => {
        let { folderId } = this.state;
        this.loadDriveData(folderId);
    };

    render() {
        const { attachments, type } = this.props.params;
        let { loading, rootFolderName, data } = this.state;
        let view = loading ?
            <Loading />
            :
            <View data={data}
                  type={type}
                  rootFolder={rootFolderName}
                  attachments={attachments}
                  onAttachFiles={this.onAttachFiles}
                  onFolderClick={this.onFolderClick}
                  onDeleteClick={this.onDeleteClick}
                  onAddFolder={this.onAddFolder}
                  onSelectRoot={this.onSelectRoot}
                  onUpload={this.onUpload}
                  onRefresh={this.onRefresh}/>;

        return (
            <div className="modal-google-drive-view">
                {view}
            </div>
        );
    }
}

module.exports = ModalGoogleDriveView;
